import { AgendaMedicaPk } from "../agenda-medica/pks/agenda-medica-pk";

export class AgendaMedicaDTO {

    idFilial: number | undefined;

    idMedico: number | undefined;

    nomeFilial: string | undefined;

    nomeMedico: string | undefined;

    diaSemana: number | undefined;

    horaAtendimento: string | undefined;

    quantidadeAtd: number | undefined;

    atdIdadeMinima: number | undefined;

    atdIdadeMaxima: number | undefined;

    atdPortadorNecessidade: boolean | undefined;

    constructor() {
    }

    get pkAgendaMedica(): AgendaMedicaPk {

        const pk: AgendaMedicaPk = new AgendaMedicaPk();

        if (this.idFilial) {
            pk.idFilial = this.idFilial;
        }

        if (this.idMedico) {
            pk.idMedico = this.idMedico;
        }

        if (this.diaSemana) {
            pk.diaSemana = this.diaSemana;
        }

        if (this.horaAtendimento) {
            pk.horaAtendimento = this.horaAtendimento;
        }

        return pk;
    }
}
